<template>
  <div>
    <div class="row border-bottom">
      <div class="col-md-1 col"></div>
      <div class="col-md-10 col text-center">
        <h3 v-translate:settings_key="lang">Settings</h3>
      </div>
      <div class="col-md-1 col"></div>
    </div>
    <div class="p-20">
      <div>
        <h3 class="mb-20" v-translate:profile_language_title="lang">
          Language
        </h3>
        <span class="language_slected">{{ participant.languageName }}</span>
      </div>
      <div>
        <!-- selected_language_info -->
        <span v-translate:selected_language_info="lang">If you wish to change the language you are using for this study, please contact your study team. Please note that you will have to withdraw from the study with your current account and register with a new email. We urge you to not change languages if it is not necessary.</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "language",
  data() {
    return {
      pid: "",
      globalElement: null
    };
  },
  computed: {
    ...mapGetters(["participant", "token"]),
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    }
  }
};
</script>
